import { api as discordApi } from './auto-generated/discord'

discordApi.enhanceEndpoints({
  endpoints: {},
})

export { discordApi }
